module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "measure",
    on: {
      "touchmove": _vm.stopPropagation
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('m-column', {
    staticClass: "form",
    attrs: {
      "title": "保费测算"
    }
  }, [_c('div', {
    staticClass: "right",
    slot: "right"
  }, [_c('span', {
    on: {
      "click": function () {
        this$1.$emit('close')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    ref: "measureBody",
    staticStyle: {
      "overflow": "auto"
    },
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "给谁投保"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.candidateInsureds
    },
    model: {
      value: (_vm.insuredValue),
      callback: function($$v) {
        _vm.insuredValue = $$v
      },
      expression: "insuredValue"
    }
  })], 1), _vm._v(" "), _c('datetime', {
    class: {
      active: _vm.insuredBirthday !== ''
    },
    attrs: {
      "default-selected-value": "1988-08-18",
      "min-year": 1900,
      "start-date": _vm.limitDate.startDate,
      "end-date": _vm.limitDate.endDate,
      "confirm-text": "确定",
      "cancel-text": "取消",
      "title": "出生日期",
      "placeholder": _vm.birthdayPlaceholder
    },
    on: {
      "on-change": _vm.getMeasurePayment
    },
    model: {
      value: (_vm.insuredBirthday),
      callback: function($$v) {
        _vm.insuredBirthday = $$v
      },
      expression: "insuredBirthday"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "所在地区",
      "list": _vm.ChinaAddressV2Data,
      "confirm-text": "确定",
      "placeholder": "请选择所在地区"
    },
    model: {
      value: (_vm.holderArea),
      callback: function($$v) {
        _vm.holderArea = $$v
      },
      expression: "holderArea"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "性别"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.sexs
    },
    on: {
      "change": _vm.changeSex
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "保障额度"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insuranceAmountsByBirthday
    },
    on: {
      "change": _vm.changeAmountsByBirthday
    },
    model: {
      value: (_vm.insuranceAmount),
      callback: function($$v) {
        _vm.insuranceAmount = $$v
      },
      expression: "insuranceAmount"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费期间"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.paymentPeriodsByBirthday
    },
    on: {
      "change": _vm.changePaymentPeriod
    },
    model: {
      value: (_vm.paymentPeriod),
      callback: function($$v) {
        _vm.paymentPeriod = $$v
      },
      expression: "paymentPeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "id": "when-wrap",
      "title": "保险期间",
      "primary": "content"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insurancePeriods
    },
    on: {
      "change": _vm.changeInsurancePeriod
    },
    model: {
      value: (_vm.orderInsurancePeriod),
      callback: function($$v) {
        _vm.orderInsurancePeriod = $$v
      },
      expression: "orderInsurancePeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费方式"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.paymentMethods
    },
    model: {
      value: (_vm.orderPaymentMethod),
      callback: function($$v) {
        _vm.orderPaymentMethod = $$v
      },
      expression: "orderPaymentMethod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    staticClass: "occupation",
    attrs: {
      "title": "职业类别"
    }
  }, [_c('span', [_vm._v("1-4类")]), _c('x-button', {
    staticClass: "holderOccupationName",
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "mini": ""
    }
  }, [_vm._v("查询职业")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c0c4a49"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Measure.vue
// module id = 639
// module chunks = 1